/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { PrimaryButton } from '@fluentui/react';
import Select from "react-select";
import { FixedSizeList as List } from "react-window";

const container = css`
  width: 850px;
  background: #f7f7f7;
    border: 1px solid #cdcdcd;
    box-shadow: 0 2px 2px -2px #ccc;
    padding: 10px 20px;
    border-radius: 4px;
    margin-bottom:20px;

  .list-container li {
    list-style: none;
    display: flex;
    align-items: center;
  }
  .header-row {
    font-weight: 400;
    border-bottom: 1px solid #cdcdcd;
  }
  .header-row div {
    font-weight: 400;
    display: inline-block;
    padding: 10px 10px 10px 15px;
  }
  .list-container {
    border: 1px solid #cdcdcd;
    box-shadow: 0 2px 2px -2px #ccc;
  }
  .list-container ul {
    margin: 0;
    padding: 0;
  }
  .list-container li div {
    display: block;
    border-right: 1px solid #cdcdcd;
    border-bottom: 1px solid #cdcdcd;
    padding: 8px 10px 8px 15px;
    background-color: #fff;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .arrow-btn {
    cursor: pointer;
    background: none;
    border: none;
    font-size: 16px;
    margin: 0px;
    color: #777777;
  }
  .arrow-btn:disabled {
    color: #ccc;
    cursor: not-allowed;
  }
`;

const CustomMenuList = (props) => {
  const height = 35;
  const itemCount = props.children.length;
  const totalHeight = Math.min(300, itemCount * height);

  return (
    <List
      height={totalHeight}
      itemCount={itemCount}
      itemSize={height}
      width="100%"
    >
      {({ index, style }) => (
        <div
          style={{
            ...style,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            padding: "0 8px",
            boxSizing: "border-box",
          }}
          title={props.children[index]?.props?.children}
        >
          {props.children[index]}
        </div>
      )}
    </List>
  );
};

const FeaturedList = ({ moveItem, addItem, saveIndividual, showUpdateBtn, removeItem, type, typeId, model, availableItems }) => {
  // Filter out items that are already in the model
  const filteredAvailableItems = availableItems?.filter(
    (item) => !model?.some((modelItem) => modelItem.id === item.id)
  );

  return (
    <div style={{width:850}}>
      {showUpdateBtn && <div className='width100 displayflex mb10' style={{justifyContent:'flex-end'}}><PrimaryButton text="Save" onClick={() => saveIndividual(model, typeId)} /></div>}
      <div className="widget fluid" css={container}>

        <div className="formRow" style={{ paddingBottom: "20px", marginTop: 10 }}>
          <Select
            components={{ MenuList: CustomMenuList }}
            options={filteredAvailableItems?.map((item) => ({
              value: item.id,
              label: item.name
            }))}
            onChange={addItem}
            placeholder={`Select ${type}`}
            isSearchable
            className="mb10"
          />
          <div className="list-container">
            <div className="header-row">
              <div style={{ width: "65px", height: 40 }}>Move</div>
              <div style={{ width: "60px", height: 40 }}>Order</div>
              <div style={{ width: "110px", height: 40 }}>CRSID</div>
              <div style={{ width: "480px", height: 40 }}>{type}</div>
              <div style={{ width: "80px", height: 40 }}>Action</div>
            </div>
            <ul>
              {model?.map((item, index) => (
                <li key={item.id}>
                  <div style={{ width: "80px", display: "flex", justifyContent: "center" }}>
                    <button
                      className="arrow-btn"
                      onClick={() => moveItem(index, -1)}
                      disabled={index === 0}
                    >
                      ▲
                    </button>
                    <button
                      className="arrow-btn"
                      onClick={() => moveItem(index, 1)}
                      disabled={index === model.length - 1}
                    >
                      ▼
                    </button>
                  </div>
                  <div style={{ width: "50px", height: 40 }}>{index}</div>
                  <div style={{ width: "110px", height: 40 }}>{item.id}</div>
                  <div style={{ width: "500px", height: 40 }}>{item.name}</div>
                  <div style={{ width: "120px", height: 40, borderRight: 0 }}>
                    <a href="#" onClick={(e) => { e.preventDefault(); removeItem(item.id); }}>Remove</a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};


export default FeaturedList;
